import { HomeOutlined } from '@lichtblick/icons';
import { CrumbType } from '@lichtblick/types';

import { Wrapper } from './Breadcrumb.styles';
import { Crumb, Divider } from './Crumb';

type BreadcrumbProps = {
  homePage: CrumbType;
  items?: CrumbType[];
};

export const Breadcrumbs = ({ homePage, items }: BreadcrumbProps) => {
  let slugs = `/qm/orders/`;

  return (
    <Wrapper>
      <Crumb href={`/${homePage.slug}`} icon={<HomeOutlined />} isActive={!items} label={homePage.label} />
      {items?.map((item, index) => {
        slugs += `${item.slug}/`;

        return (
          <Wrapper key={item.label}>
            <Divider />
            <Crumb href={slugs} isActive={index === items.length - 1} label={item.label} />
          </Wrapper>
        );
      })}
    </Wrapper>
  );
};
